import React from 'react'
import NotificationContainer from 'containers/Notification'

const Notification = () => {
    return (
       
        <NotificationContainer />
        
    )
}

export default Notification
